<label class="field-label"><%= I18n.patient.labels.patient_proxy %></label>
<div class="field-input select">
  <select>
    <% jQuery.each(patient_proxies, function(_, patient_proxy) { %>
      <option
        data-id="<%- patient_proxy.id %>"
        data-id-type="<%- patient_proxy.id_type %>"
        data-date-of-birth="<%- patient_proxy.date_of_birth %>"
        <% if (patient_proxy.id == patient_id && patient_proxy.id_type == patient_id_type) { %>selected<% } %>
      >
        <%- patient_proxy.name %>
      </option>
    <% }) %>
  </select>
</div>
